import { Locale } from "@hermes/locale";

export enum SPAURLFragments {
    CONTENT = "content",
    PRODUCT = "product",
    CATEGORY = "category",
}
export function transformSPALink(locale: Locale, href: string): string {
    const spaLink = href.replace(
        new RegExp(`.*${locale.urlPrefix}(/.*)`),
        "$1",
    );
    return spaLink.charAt(spaLink.length - 1) === "/" ? spaLink : `${spaLink}/`;
}

/**
 * Checks the first URL fragment after the local to check if it's
 * an Angular page
 */
export function isSPA(locale: Locale, pathWithLocale: string): boolean {
    const urlPrefix = locale.urlPrefix;
    let cutString = pathWithLocale.slice(
        Math.max(0, pathWithLocale.indexOf(urlPrefix)),
    );
    cutString = cutString.slice(urlPrefix.length).slice(1);
    return (
        cutString.slice(0, cutString.indexOf("/")).toUpperCase() in
        SPAURLFragments
    );
}
